<template>
  <div>
    <div v-if="isLoading">
      <LoadingSpinner v-if="isLoading" />
    </div>

    <div v-else class="card card-body shadow-sm mt-0">
      <!-- Header -->
      <div class="header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          Detalhes da Matrícula nº {{ detalhes.matricula.id }} - Contrato nº
          <span v-if="detalhes.matricula.numero_contrato">
            {{ detalhes.matricula.numero_contrato }}
          </span>
          <!-- Ícone existente -->
          <i class="bi bi-file-earmark-text text-primary mx-2" title="Imprimir Contrato"
            style="cursor: pointer;"
            @click="abrirImprimirContrato" />
          <!-- Novo ícone para Imprimir Recibo -->
          <i class="bi bi-receipt text-success m3-2" title="Imprimir Recibo"
            style="cursor: pointer;"
            @click="abrirImprimirRecibo" />
        </h4>

        <button class="btn btn-secondary" @click="cancelar">Voltar</button>
      </div>

      <!-- Dados do Contratante -->
      <div class="form-content mt-3">
        <FormSection title="Dados do Contratante">
          <template #headerActions>
            <i class="bi bi-pencil-fill text-warning mx-2"
              title="Editar Contratante"
              @click="editarPessoa('responsavel')" />
          </template>
          <p><strong>Nome:</strong> {{ detalhes.responsavel.nome }}</p>
          <p><strong>CPF:</strong> {{ responsavelCPFFormatado }}</p>
          <p><strong>RG:</strong> {{ detalhes.responsavel.rg }}</p>
          <p><strong>Data de Nascimento:</strong> {{ globalUtils.formatarData(detalhes.responsavel.data_nascimento) }}</p>
          <p><strong>Sexo:</strong> {{ responsavelSexoFormatado }}</p>
          <p><strong>Telefone principal:</strong> {{ formatarTelefoneComDdi(detalhes.responsavel?.telefone, detalhes.responsavel?.telefone_ddi) || 'Não informado' }}</p>
          <p><strong>Celular / WhatsApp:</strong> {{ formatarTelefoneComDdi(detalhes.responsavel?.celular, detalhes.responsavel?.celular_ddi) || 'Não informado' }}</p>
          <p><strong>E-mail:</strong> {{ detalhes.responsavel.email }}</p>
          <p><strong>Endereço:</strong> {{ detalhes.responsavel.endereco }}</p>
          <p><strong>Número:</strong> {{ detalhes.responsavel.numero }}</p>
          <p><strong>Complemento:</strong> {{ detalhes.responsavel.complemento }}</p>
          <p><strong>Bairro:</strong> {{ detalhes.responsavel.bairro }}</p>
          <p><strong>Estado:</strong> {{ detalhes.responsavel.estado_nome || detalhes.responsavel.estado_cod }}</p>
          <p><strong>Município:</strong> {{ detalhes.responsavel.municipio_nome || detalhes.responsavel.municipio_cod }}</p>
          <p><strong>CEP:</strong> {{ detalhes.responsavel.cep }}</p>
          <p><strong>Nacionalidade:</strong> {{ detalhes.responsavel.nacionalidade || 'Não informado' }}</p>
          <p><strong>Autorização de uso de imagem:</strong> {{ detalhes.matricula.direito_imagem ? 'Sim' : 'Não' }}</p>
          <p><strong>Naturalidade:</strong> {{ detalhes.responsavel.naturalidade || 'Não informado' }}</p>
          <p><strong>Observações:</strong> {{ detalhes.responsavel.observacoes }}</p>
        </FormSection>
      </div>
      <!-- Dados do Aluno -->
      <FormSection title="Dados do Aluno">
        <template #headerActions>
          <i class="bi bi-pencil-fill text-warning mx-2"
             title="Editar Aluno"
             @click="editarPessoa('aluno')" />
        </template>
        <p><strong>Nome:</strong> {{ detalhes.aluno.nome }}</p>
        <p><strong>CPF:</strong> {{ alunoCPFFormatado }}</p>
        <p><strong>RG:</strong> {{ detalhes.aluno.rg }}</p>
        <p><strong>Data de Nascimento:</strong> {{ globalUtils.formatarData(detalhes.aluno.data_nascimento) }}</p>
        <p><strong>Sexo:</strong> {{ alunoSexoFormatado }}</p>
        <p><strong>Telefone principal:</strong> {{ formatarTelefoneComDdi(detalhes.aluno?.telefone, detalhes.aluno?.telefone_ddi) || 'Não informado' }}</p>
        <p><strong>Celular / WhatsApp:</strong> {{ formatarTelefoneComDdi(detalhes.aluno?.celular, detalhes.aluno?.celular_ddi) || 'Não informado' }}</p>
        <p><strong>E-mail:</strong> {{ detalhes.aluno.email }}</p>
        <p><strong>Endereço:</strong> {{ detalhes.aluno.endereco }}</p>
        <p><strong>Número:</strong> {{ detalhes.aluno.numero }}</p>
        <p><strong>Complemento:</strong> {{ detalhes.aluno.complemento }}</p>
        <p><strong>Bairro:</strong> {{ detalhes.aluno.bairro }}</p>
        <p><strong>Estado:</strong> {{ detalhes.aluno.estado_nome || detalhes.aluno.estado_cod }}</p>
        <p><strong>Município:</strong> {{ detalhes.aluno.municipio_nome || detalhes.aluno.municipio_cod }}</p>
        <p><strong>CEP:</strong> {{ detalhes.aluno.cep }}</p>
        <p><strong>Nacionalidade:</strong> {{ detalhes.aluno.nacionalidade || 'Não informado' }}</p>
        <p><strong>Naturalidade:</strong> {{ detalhes.aluno.naturalidade || 'Não informado' }}</p>
        <p><strong>Observações:</strong> {{ detalhes.aluno.observacoes }}</p>
      </FormSection>

      <!-- Plano de Matrícula -->
      <FormSection title="Dados do Plano de Matrícula">
        <template #headerActions>
          <div class="icons-container">
            <i class="bi bi-headset text-warning" title="Incluir Observação" @click="abrirModalIncluirObservacao" />
            <i class="bi bi-arrow-clockwise text-success" title="Renovar Matrícula" @click="abrirModalRenovar" />
            <i class="bi bi-arrow-repeat text-info" title="Trocar Nível/Turma" @click="abrirModalTrocarNivel" />
            <i class="bi bi-arrow-left-right text-primary" title="Trocar Plano" @click="abrirModalTrocarPlano" />
          </div>
        </template>
        <p><strong>Início da Vigência:</strong> {{ globalUtils.formatarData(detalhes.matricula.inicio_vigencia) }}</p>
        <p>
          <strong>Término da Vigência: </strong>
          <span :class="vencimentoClasse(detalhes.matricula.termino_vigencia)">
            {{ globalUtils.formatarData(detalhes.matricula.termino_vigencia) }}
          </span>
        </p>
        <p><strong>Status:</strong> <span :style="{ color: statusColor }">{{ statusExibido }}</span></p>
        <p><strong>Categoria:</strong> {{ getCategoriaNome(detalhes.matricula.categoria_id) }}</p>
        <p><strong>Tipo de Plano:</strong>
          {{ getTipoPlanoDescricao(detalhes.matricula?.tipo_plano_id) }}
        </p>
        <p><strong>Qtd. de Parcelas:</strong>
          {{ detalhes.matricula.quantidade_parcelas ?? '-' }}
        </p>
        <p><strong>Aulas por Semana:</strong>
          {{ detalhes.matricula.aulas_semana ?? '-' }}
        </p>
        <p><strong>Nível:</strong>
          {{ getNivelDescricao(detalhes.matricula.nivel_id) }}
        </p>
        <p><strong>Turmas:</strong></p>
        <ul>
          <li v-for="(t, i) in detalhes.turmas" :key="i">{{ t.turma_completa }}</li>
        </ul>
      </FormSection>

      <!-- Dados Financeiros -->
      <FormSection title="Dados Financeiros">
        <p><strong>Data da Matrícula:</strong> {{ globalUtils.formatarData(detalhes.matricula.data_matricula) }}</p>
        <p><strong>Valor:</strong> {{ globalUtils.formatarValor(detalhes.matricula.valor) }}</p>
        <p><strong>Desconto (%):</strong> {{ detalhes.matricula.desconto }}</p>
        <p><strong>Valor com Desconto:</strong> {{ globalUtils.formatarValor(detalhes.matricula.valor_com_desconto) }}</p>
        <p><strong>Convênio:</strong> {{ detalhes.catalogos.convenios.find(c=>c.id===detalhes.matricula.convenio_id)?.nome || 'Não informado' }}</p>
        <p><strong>Forma de Pagamento:</strong> {{
          detalhes.catalogos.formasPagamento.find(f => Number(f.id) === Number(detalhes.pagamentoMatricula?.forma_pagamento_id))?.nome
          || 'Não informado'
        }}</p>
        <template v-if="isCheque(detalhes.pagamentoMatricula?.forma_pagamento_id)">
          <p><strong>Banco nº:</strong> {{ detalhes.pagamentoMatricula.banco_numero }}</p>
          <p><strong>Agência:</strong> {{ detalhes.pagamentoMatricula.agencia }}</p>
          <p><strong>Cheque nº:</strong> {{ detalhes.pagamentoMatricula.cheque_numero }}</p>
        </template>
        <p><strong>Conta Financeira:</strong> {{ formatarConta(detalhes.pagamentoMatricula?.conta_financeira_id) }}</p>
        <p><strong>Data de Vencimento:</strong> {{ globalUtils.formatarData(detalhes.matricula.data_vencimento) }}</p>
        <p><strong>Data de Pagamento:</strong>
          <span v-if="detalhes.pagamentoMatricula && detalhes.pagamentoMatricula.data_pagamento">
            {{ globalUtils.formatarData(detalhes.pagamentoMatricula.data_pagamento) }}
          </span>
          <span v-else style="color:red;">Pendente</span>
        </p>

        <p><strong>Recebimento em:</strong>
          <span v-if="detalhes.pagamentoMatricula && detalhes.pagamentoMatricula.data_recebimento">
            {{ globalUtils.formatarData(detalhes.pagamentoMatricula.data_recebimento) }}
          </span>
          <span v-else>
            -
          </span>
        </p>
      </FormSection>

      <!-- Mensalidades -->
      <FormSection title="Mensalidade">
        <p v-if="erroComposicaoTroca" class="alert alert-danger">{{ erroComposicaoTroca }}</p>
        <div v-if="composicaoTroca" class="alert alert-info">
          <strong>Composição registrada na troca</strong>
          <p>Novo plano: {{ globalUtils.formatarValor(composicaoTroca.valor_plano) }} ·
            Composição anterior: {{ globalUtils.formatarValor(composicaoTroca.valor_anterior) }} ·
            Pago na data da troca: {{ globalUtils.formatarValor(composicaoTroca.valor_pago) }} ·
            Complemento criado: {{ globalUtils.formatarValor(composicaoTroca.complemento) }}.</p>
          <details><summary>Obrigações anteriores preservadas — situação atual</summary>
            <div class="table-responsive"><table class="table table-sm">
              <thead><tr><th>Obrigação</th><th>Contrato</th><th>Vencimento</th><th>Valor</th><th>Situação</th></tr></thead>
              <tbody><tr v-for="p in composicaoTroca.obrigacoes_preservadas" :key="p.id">
                <td>#{{ p.id }}</td><td>{{ p.contrato }}</td><td>{{ globalUtils.formatarData(p.vencimento) }}</td>
                <td>{{ globalUtils.formatarValor(p.valor) }}</td><td>{{ p.pago ? 'Paga' : 'Pendente' }}</td>
              </tr></tbody>
            </table></div>
          </details>
          <p class="mb-0">Os lançamentos do contrato atual abaixo correspondem ao complemento. As obrigações anteriores permanecem exigíveis quando pendentes.</p>
        </div>
        <div class="mensalidade-dados-principais">
          <div>
            <span class="mensalidade-dado-label">Valor</span>
            <strong>{{ globalUtils.formatarValor(detalhes.matricula?.valor_mensalidade || 0) }}</strong>
          </div>

          <div>
            <span class="mensalidade-dado-label">Desconto</span>
            <strong>{{ detalhes.matricula?.desconto_mensalidade || 0 }}%</strong>
          </div>

          <div>
            <span class="mensalidade-dado-label">Valor com desconto</span>
            <strong>{{ globalUtils.formatarValor(valorComDescontoMensalidade) }}</strong>
          </div>

          <div>
            <span class="mensalidade-dado-label">1º vencimento</span>
            <strong>{{ globalUtils.formatarData(detalhes.matricula?.primeiro_vencimento) }}</strong>
          </div>

          <div>
            <span class="mensalidade-dado-label">Parcelas contratuais</span>
            <strong>{{ detalhes.matricula?.quantidade_pagamentos || 0 }}</strong>
          </div>

          <div>
            <span class="mensalidade-dado-label">{{ detalhes.composicaoTroca ? 'Complemento desta troca' : (mensalidadeGerenciada ? 'Valor contratual' : 'Valor total esperado') }}</span>
            <strong>{{ valorTotalMensalidade == null ? 'Não informado no legado' : globalUtils.formatarValor(mensalidadeGerenciada ? valorTotalMensalidade : totalEsperadoMensalidade) }}</strong>
            <div v-if="detalhes.composicaoTroca" class="small mt-2">
              Valor do novo plano no período: {{ globalUtils.formatarValor(detalhes.composicaoTroca.valor_plano) }}<br>
              Valor já representado nos contratos anteriores: {{ globalUtils.formatarValor(detalhes.composicaoTroca.valor_anterior) }}<br>
              Complemento desta troca: {{ globalUtils.formatarValor(detalhes.composicaoTroca.complemento) }}
            </div>
          </div>
        </div>

        <div
          v-if="detalhes.composicaoTroca || pagamentosContrato?.length"
          class="conferencia-mensalidade mt-3 mb-3"
        >
          <div class="row g-2">
            <div class="col-md-4">
              <div class="conferencia-card">
                <span class="conferencia-label">{{ detalhes.composicaoTroca ? 'Complemento desta troca' : 'Total esperado' }}</span>
                <strong>{{ globalUtils.formatarValor(totalEsperadoMensalidade) }}</strong>
              </div>
            </div>

            <div class="col-md-4">
              <div class="conferencia-card">
                <span class="conferencia-label">{{ detalhes.composicaoTroca ? 'Total dos novos lançamentos ordinários' : 'Total dos lançamentos' }}</span>
                <strong>{{ globalUtils.formatarValor(totalLancamentosMensalidade) }}</strong>
              </div>
            </div>

            <div class="col-md-4">
              <div
                class="conferencia-card"
                :class="{
                  'conferencia-ok': !existeDiferencaMensalidade,
                  'conferencia-alerta': existeDiferencaMensalidade
                }"
              >
                <span class="conferencia-label">{{ detalhes.composicaoTroca ? 'Diferença para o complemento' : 'Diferença' }}</span>

                <strong v-if="!existeDiferencaMensalidade">
                  R$ 0,00
                </strong>

                <strong v-else-if="diferencaTotalMensalidade > 0">
                  +{{ globalUtils.formatarValor(diferencaMensalidadeAbsoluta) }}
                </strong>

                <strong v-else>
                  -{{ globalUtils.formatarValor(diferencaMensalidadeAbsoluta) }}
                </strong>
              </div>
            </div>
          </div>

          <div
            class="alert mt-2 mb-0 py-2"
            :class="existeDiferencaMensalidade ? 'alert-warning' : 'alert-success'"
          >
            <i
              class="bi me-1"
              :class="existeDiferencaMensalidade
                ? 'bi-exclamation-triangle-fill'
                : 'bi-check-circle-fill'"
            ></i>

            {{ mensagemDiferencaMensalidade }}
          </div>
          <div v-if="mensagemComposicoesMensalidade" class="alert alert-info mt-2 mb-0 py-2">{{ mensagemComposicoesMensalidade }}</div>
        </div>

        <div
          v-if="pagamentosContrato?.length"
          class="mensalidade-resumo d-flex flex-wrap gap-2 mb-3"
        >
          <span class="badge bg-primary">
            {{ detalhes.matricula?.quantidade_pagamentos || 0 }} parcelas contratuais
          </span>

          <span class="badge bg-light text-dark border">
            {{ pagamentosContrato.length }} registros financeiros
          </span>

          <span
            v-if="quantidadeChequesSubstituidos"
            class="badge bg-secondary"
          >
            {{ quantidadeChequesSubstituidos }} cheques substituídos
          </span>

          <span
            v-if="quantidadePagamentosSubstitutos"
            class="badge bg-info text-dark"
          >
            {{ quantidadePagamentosSubstitutos }} pagamentos substitutos
          </span>

          <span
            v-if="quantidadeConciliacoesAtivas"
            class="badge bg-success"
          >
            {{ quantidadeConciliacoesAtivas }} conciliações ativas
          </span>
        </div>

        <div v-if="valorParcelasAdicionais > 0" class="alert alert-light border py-2 mb-3">
          <div>
            <strong>Parcelas adicionais:</strong>
            <span class="text-success">
              {{ globalUtils.formatarValor(valorParcelasAdicionais) }}
            </span>
          </div>

          <div>
            <strong>Total esperado com adicionais:</strong>
            <span class="text-success">
              {{ globalUtils.formatarValor(mensalidadeGerenciada ? valorTotalComParcelasAdicionaisPrevisto : valorTotalComParcelasAdicionais) }}
            </span>
          </div>
        </div>

        <div
          v-if="pagamentosContrato?.length"
          class="table-responsive mensalidade-table-responsive"
        >
          <div ref="tabelaMensalidade">
            <table class="table table-bordered mensalidade-table mb-0">
              <thead>
                <tr>
                  <th class="col-parcela">Parcela</th>
                  <th class="col-situacao">Situação</th>
                  <th class="col-forma">Forma</th>
                  <th class="col-data">Vencimento</th>
                  <th class="col-valor">Valor</th>
                  <th class="col-data">Pagamento</th>
                  <th class="col-data">Recebimento</th>
                  <th class="col-detalhes text-center">Detalhes</th>
                </tr>
              </thead>

              <tbody>
                <template
                  v-for="pag in pagamentosContratoOrdenados"
                  :key="pag.id"
                >
                  <tr :class="classeLinhaPagamento(pag)">
                    <td class="text-center">
                      <span
                        v-if="pag.adicional"
                        class="badge bg-warning text-dark"
                      >
                        Adicional
                      </span>

                      <strong v-else>
                        {{ numeroParcelaContratual(pag) || '-' }}
                      </strong>
                    </td>

                    <td>
                      <span
                        class="badge"
                        :class="situacaoPagamento(pag).classe"
                      >
                        {{ situacaoPagamento(pag).texto }}
                      </span>

                      <i
                        v-if="pag.bloqueado_por_conciliacao"
                        class="bi bi-lock-fill text-success ms-1"
                        title="Registro protegido por conciliação ativa"
                      ></i>
                    </td>

                    <td>{{ getFormaPagamentoNome(pag.forma_pagamento_id) }}</td>

                    <td>{{ globalUtils.formatarData(pag.data_vencimento) }}</td>

                    <td>{{ globalUtils.formatarValor(pag.valor) }}</td>

                    <td>
                      <span v-if="pag.data_pagamento">
                        {{ globalUtils.formatarData(pag.data_pagamento) }}
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>

                    <td>
                      <span v-if="pag.data_recebimento">
                        {{ globalUtils.formatarData(pag.data_recebimento) }}
                      </span>
                      <span v-else class="text-muted">—</span>
                    </td>

                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm btn-detalhes-pagamento"
                        :title="detalhesPagamentoAberto(pag)
                          ? 'Ocultar detalhes'
                          : 'Ver dados financeiros, histórico e conciliação'"
                        @click="alternarDetalhesPagamento(pag)"
                      >
                        <i
                          class="bi"
                          :class="detalhesPagamentoAberto(pag)
                            ? 'bi-chevron-up'
                            : 'bi-sliders'"
                        ></i>
                      </button>
                    </td>
                  </tr>

                  <tr
                    v-if="detalhesPagamentoAberto(pag)"
                    class="linha-detalhes-pagamento"
                  >
                    <td colspan="8">
                      <div class="pagamento-detalhes-grid">
                        <div>
                          <span class="detalhe-label">Conta financeira</span>
                          <strong>{{ formatarConta(pag.conta_financeira_id) }}</strong>
                        </div>

                        <div>
                          <span class="detalhe-label">Autorização</span>
                          <strong>{{ pag.numero_autorizacao || 'Não informada' }}</strong>
                        </div>

                        <div>
                          <span class="detalhe-label">Registro</span>
                          <strong>#{{ pag.id }}</strong>
                        </div>

                        <div v-if="isCheque(pag.forma_pagamento_id)">
                          <span class="detalhe-label">Cheque</span>
                          <strong>
                            Banco {{ pag.banco_numero || '-' }}
                            / Ag. {{ pag.agencia || '-' }}
                            / Nº {{ pag.cheque_numero || '-' }}
                          </strong>
                        </div>

                        <div v-if="pag.cheque_data_devolucao">
                          <span class="detalhe-label">Devolução</span>
                          <strong>
                            {{ globalUtils.formatarData(pag.cheque_data_devolucao) }}
                          </strong>
                        </div>

                        <div v-if="pag.cheque_data_reapresentacao">
                          <span class="detalhe-label">Reapresentação</span>
                          <strong>
                            {{ globalUtils.formatarData(pag.cheque_data_reapresentacao) }}
                          </strong>
                        </div>

                        <div v-if="pag.cheque_data_substituicao">
                          <span class="detalhe-label">Substituição</span>
                          <strong>
                            {{ globalUtils.formatarData(pag.cheque_data_substituicao) }}
                          </strong>
                        </div>

                        <div v-if="pag.pagamento_substituto_id">
                          <span class="detalhe-label">Substituído pelo pagamento</span>
                          <strong>#{{ pag.pagamento_substituto_id }}</strong>
                        </div>

                        <div v-if="pag.pagamento_substituto">
                          <span class="detalhe-label">Pagamento substituto de</span>
                          <strong>#{{ pag.pagamento_origem_id || '-' }}</strong>
                        </div>

                        <div v-if="pag.bloqueado_edicao">
                          <span class="detalhe-label">Proteção do registro</span>
                          <strong>
                            {{ formatarMotivosBloqueio(pag.motivos_bloqueio) }}
                          </strong>
                        </div>
                      </div>

                      <div
                        v-if="Array.isArray(pag.conciliacoes_ativas) && pag.conciliacoes_ativas.length"
                        class="detalhe-bloco mt-3"
                      >
                        <strong>
                          <i class="bi bi-bank me-1"></i>
                          Conciliações ativas
                        </strong>

                        <div
                          v-for="conciliacao in pag.conciliacoes_ativas"
                          :key="conciliacao.vinculo_id"
                          class="detalhe-item mt-1"
                        >
                          Vínculo #{{ conciliacao.vinculo_id }}
                          · Item {{ conciliacao.origem_item_tipo }} #{{ conciliacao.origem_item_id }}
                          · {{ conciliacao.tipo_vinculo || 'NORMAL' }}
                          <template v-if="conciliacao.valor_utilizado != null">
                            · {{ globalUtils.formatarValor(conciliacao.valor_utilizado) }}
                          </template>
                        </div>
                      </div>

                      <div
                        v-if="Array.isArray(pag.eventos_cheque) && pag.eventos_cheque.length"
                        class="detalhe-bloco mt-3"
                      >
                        <strong>
                          <i class="bi bi-clock-history me-1"></i>
                          Histórico do cheque
                        </strong>

                        <div
                          v-for="evento in pag.eventos_cheque"
                          :key="evento.evento_id"
                          class="detalhe-item mt-1"
                        >
                          {{ globalUtils.formatarData(evento.data_evento) }}
                          · {{ formatarTipoEventoCheque(evento.tipo_evento) }}
                          <template v-if="evento.motivo">
                            · {{ evento.motivo }}
                          </template>
                          <template v-if="evento.pagamento_substituto_id">
                            · Pagamento substituto #{{ evento.pagamento_substituto_id }}
                          </template>
                        </div>
                      </div>

                      <div
                        v-if="pag.observacoes || pag.cheque_observacao || pag.cheque_motivo_devolucao"
                        class="detalhe-bloco mt-3"
                      >
                        <strong>
                          <i class="bi bi-card-text me-1"></i>
                          Observações
                        </strong>

                        <div
                          v-if="pag.cheque_motivo_devolucao"
                          class="detalhe-item mt-1"
                        >
                          <strong>Motivo da devolução:</strong>
                          {{ pag.cheque_motivo_devolucao }}
                        </div>

                        <div
                          v-if="pag.cheque_observacao"
                          class="detalhe-item mt-1 texto-com-quebras"
                        >
                          {{ pag.cheque_observacao }}
                        </div>

                        <div
                          v-if="pag.observacoes"
                          class="detalhe-item mt-1 texto-com-quebras"
                        >
                          {{ pag.observacoes }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>

        <div v-else>
          <p v-if="!detalhes.composicaoTroca">Nenhuma parcela encontrada para este contrato.</p>
        </div>

        <p v-if="detalhes.composicaoTroca && !pagamentosContrato.filter(p => !p.adicional && !isRegistroOriginalSubstituido(p)).length" :class="Number(detalhes.composicaoTroca.complemento) === 0 ? 'alert alert-info' : 'alert alert-warning'">
          {{ Number(detalhes.composicaoTroca.complemento) === 0
            ? 'Esta troca não gerou novas parcelas. Os pagamentos dos contratos anteriores foram preservados, com suas situações e vencimentos originais.'
            : 'Nenhuma nova parcela ordinária encontrada, embora esta troca tenha complemento a lançar. Confira a diferença acima.' }}
        </p>

        <p class="mt-3 mb-0">
          <strong>Observações da matrícula:</strong>
          {{ detalhes.matricula.observacoes || 'Nenhuma observação.' }}
        </p>
      </FormSection>

      <!-- Pós-venda e históricos -->
      <div class="form-content mt-3">
        <FormSection title="Histórico de Pós-venda">
          <div v-if="detalhes.posvendas && detalhes.posvendas.length > 0">
            <p>
              Última ação em
              {{ globalUtils.formatarData(detalhes.posvendas[0].data_contato) }}
              por {{ detalhes.posvendas[0].nome_usuario }}
            </p>
            <div
              class="table-responsive mt-1"
              v-if="historicoComAtual && historicoComAtual.length > 0"
            >
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Contato</th>
                    <th>Descrição</th>
                    <th>Agend.</th>
                    <th>Por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(h, i) in historicoComAtual" :key="h.id">
                    <td>{{ i + 1 }}</td>
                    <td>{{ globalUtils.formatarData(h.data_contato) }}</td>
                    <td>{{ h.descricao }}</td>
                    <td>{{ globalUtils.formatarData(h.proximo_contato) }}</td>
                    <td>{{ h.nome_usuario }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Nenhum histórico de pós-venda registrado.</p>
            </div>
          </div>
          <div v-else>
            <p>Nenhuma ação de pós-venda registrada.</p>
          </div>
        </FormSection>
      </div>

      <!-- Seção Observações do Aluno -->
      <div class="form-content mt-3">
        <FormSection title="Observações do Aluno">

          <!-- ✅ Força layout em coluna dentro do FormSection -->
          <div class="d-flex flex-column w-100">

            <!-- Prospecção (CRM) — sempre acima -->
            <div
              v-if="detalhes.prospeccao_origem"
              class="mb-3 p-2 border rounded w-100"
              style="background:#f8f9fa;"
            >
              <div>
                <strong>Prospecção iniciada por:</strong>
                {{ detalhes.prospeccao_origem.usuario_criador || '-' }}
              </div>

              <div>
                <strong>Última interação na prospecção:</strong>
                {{ detalhes.prospeccao_origem.usuario_ultimo || '-' }}
              </div>

              <div class="text-muted" style="font-size:12px;">
                Contato: {{ globalUtils.formatarData(detalhes.prospeccao_origem.data_contato) || '-' }}
                &nbsp;|&nbsp;
                Matrícula: {{ globalUtils.formatarData(detalhes.prospeccao_origem.data_acao) || '-' }}
                &nbsp;|&nbsp;
                Prospecção ID: {{ detalhes.prospeccao_origem.id }}
              </div>
            </div>

            <div
              v-else
              class="mb-3 text-muted w-100"
              style="font-size:12px;"
            >
              Nenhuma prospecção vinculada a este contrato.
            </div>

            <!-- Tabela — abaixo -->
            <div
              class="table-responsive mt-1 w-100"
              v-if="detalhes.observacoesAluno && detalhes.observacoesAluno.length > 0"
            >
              <table class="table table-bordered observacoes-aluno-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th class="col-observacao-aluno">Observação</th>
                    <th class="col-usuario-observacao">Por</th>
                    <th class="text-center">Ações</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(obs, index) in detalhes.observacoesAluno"
                    :key="obs.id"
                  >
                    <td>{{ index + 1 }}</td>

                    <td>
                      {{ globalUtils.formatarData(obs.data_observacao) }}
                    </td>

                    <td class="col-observacao-aluno">
                      <div class="obs-pre">
                        <template v-if="obs.falta_avisada">
                          {{
                            "Falta avisada para o dia " +
                            globalUtils.formatarData(obs.data_falta) +
                            " - " +
                            limparMarcadorHistorico(obs.observacao)
                          }}
                        </template>

                        <template v-else>
                          {{ limparMarcadorHistorico(obs.observacao) }}
                        </template>
                      </div>
                    </td>

                    <td class="col-usuario-observacao">
                      {{ obs.nome_usuario }}
                    </td>

                    <td class="text-center">

                      <i
                        v-if="
                          obs.falta_avisada &&
                          !faltaAvisadaJaRevisada(obs)
                        "
                        class="bi bi-pencil-fill text-warning"
                        role="button"
                        title="Alterar ou cancelar falta avisada"
                        style="cursor: pointer;"
                        @click="editarObservacao(obs)"
                      ></i>

                      <i
                        v-else-if="obs.falta_avisada"
                        class="bi bi-check-circle-fill text-muted"
                        title="Esta falta avisada já foi cancelada ou alterada"
                        style="font-size: 0.9rem;"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="w-100">
              <p>Nenhuma observação registrada.</p>
            </div>

          </div>
        </FormSection>
      </div>

      <!-- Histórico de Renovações -->
      <FormSection title="Histórico de Renovações">
        <div class="table-responsive mt-1" v-if="detalhes.historicos.renovacoes.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Contrato</th>
                <th>Plano</th>
                <th>Cadastro</th>
                <th>Vigência</th>
                <th>Por</th>
                <th class="text-center">Recibo</th>
                <!-- NOVO -->
                <th v-if="hasPermission('cancelar_renovacao')" class="text-center">Cancelar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r,i) in detalhes.historicos.renovacoes" :key="r.id">
                <td>{{ i+1 }}</td>
                <td>{{ r.numero_contrato }}</td>
                <td>{{ r.tipo_plano }}</td>
                <td>{{ globalUtils.formatarData(r.created_at) }}</td>
                <td>{{ globalUtils.formatarData(r.inicio_vigencia) }} a {{ globalUtils.formatarData(r.termino_vigencia) }}</td>
                <td>{{ r.nome_usuario }}</td>
                <td class="text-center">
                  <i
                    class="bi bi-receipt text-success"
                    role="button"
                    style="cursor: pointer; font-size: 0.9rem;"
                    :title="`Abrir recibo do contrato ${r.numero_contrato}`"
                    @click="abrirImprimirReciboContrato(r.numero_contrato)"
                  ></i>
                </td>

                <!-- NOVA COLUNA: ícone só para a ÚLTIMA renovação -->
                <td v-if="hasPermission('cancelar_renovacao')" class="text-center">
                  <i
                    v-if="hasPermission('cancelar_renovacao') && r.id === ultimaRenovacaoId"
                    class="bi bi-x-circle-fill text-danger"
                    role="button"
                    style="cursor: pointer; font-size: 0.9rem;"
                    :title="`Cancelar / reverter a renovação do contrato ${r.numero_contrato}`"
                    @click="reverterUltimaRenovacao(r)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else><p>Nenhuma renovação registrada.</p></div>
      </FormSection>

      <!-- Histórico de Trocas de Nível -->
      <FormSection title="Histórico de Trocas de Nível">
        <div class="table-responsive mt-1" v-if="detalhes.historicos.trocasNivel.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Contrato</th>
                <th>Novo Nível</th>
                <th>Nível Anterior</th>
                <th>Data</th>
                <th>Por</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, i) in detalhes.historicos.trocasNivel" :key="t.id">
                <td>{{ i + 1 }}</td>
                <td>{{ t.numero_contrato }}</td>
                <td>{{ t.nivel }}</td>
                <td>{{ t.nivel_anterior }}</td>
                <td>{{ globalUtils.formatarData(t.created_at) }}</td>
                <td>{{ t.nome_usuario }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p>Nenhuma troca de nível registrada.</p>
        </div>
      </FormSection>

      <!-- Histórico de Trocas de Plano -->
      <FormSection title="Histórico de Trocas de Plano">
        <div class="table-responsive mt-1" v-if="detalhes.historicos.trocasPlano.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Contrato</th>
                <th>Plano</th>
                <th>Cadastro</th>
                <th>Vigência</th>
                <th>Por</th>
                <th class="text-center">Recibo</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(tp, i) in detalhes.historicos.trocasPlano" :key="tp.id">
                <td>{{ i + 1 }}</td>
                <td>{{ tp.numero_contrato || '-' }}</td>
                <td>{{ tp.tipo_plano }}</td>
                <td>{{ tp.cadastro_c04_br || globalUtils.formatarData(tp.created_at) }}</td>
                <td>
                  {{ globalUtils.formatarData(tp.inicio_vigencia) }}
                  a
                  {{ globalUtils.formatarData(tp.termino_vigencia) }}
                </td>
                <td>{{ tp.nome_usuario }}</td>

                <td class="text-center">
                  <i
                    v-if="tp.numero_contrato"
                    class="bi bi-receipt text-success"
                    role="button"
                    style="cursor: pointer; font-size: 0.9rem;"
                    :title="`Abrir recibo do contrato ${tp.numero_contrato}`"
                    @click="abrirImprimirReciboContrato(tp.numero_contrato)"
                  ></i>

                  <span
                    v-else
                    class="text-muted"
                    title="Contrato não informado no histórico da troca de plano"
                  >
                    -
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else>
          <p>Nenhuma troca de plano registrada.</p>
        </div>
      </FormSection>

      <!-- Histórico de Trancamento de Matrícula -->
      <FormSection title="Histórico de Trancamento de Matrícula">
        <div class="table-responsive mt-1" v-if="detalhes.historicos.trancamentos.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>#</th><th>Contrato</th><th>Período do Trancamento</th><th>Observações</th><th>Por</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr,i) in detalhes.historicos.trancamentos" :key="tr.id">
                <td>{{ i+1 }}</td>
                <td>{{ tr.numero_contrato }}</td>
                <td>{{ globalUtils.formatarData(tr.inicio) }} a {{ globalUtils.formatarData(tr.fim) }}</td>
                <td>{{ tr.observacoes }}</td>
                <td>{{ tr.nome_usuario }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else><p>Nenhum trancamento registrado.</p></div>
      </FormSection>

      <!-- Histórico de Antecipação de Destrancamento de Matrícula -->
      <FormSection title="Histórico de Antecipação de Destrancamento de Matrícula">
        <div class="table-responsive mt-1" v-if="detalhes.historicos.destrancamentos.length">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>#</th><th>Contrato</th><th>Data do Destrancamento</th><th>Observações</th><th>Por</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dt,i) in detalhes.historicos.destrancamentos" :key="dt.id">
                <td>{{ i+1 }}</td>
                <td>{{ dt.numero_contrato }}</td>
                <td>{{ globalUtils.formatarData(dt.data_destrancamento) }}</td>
                <td>{{ dt.observacoes }}</td>
                <td>{{ dt.nome_usuario }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else><p>Nenhuma antecipação de destrancamento registrada.</p></div>
      </FormSection>

      <!-- Modais -->
      <IncluirObservacao
        v-if="!isLoading && detalhes.matricula && exibirModalIncluirObservacao"
        :mostrar="exibirModalIncluirObservacao"
        :matriculaId="detalhes.matricula?.id"
        :aluno="detalhes.aluno?.nome"
        :alunoId="detalhes.matricula?.aluno_id"
        :nomeUsuario="($globalState && $globalState.userName) ? $globalState.userName : ''"
        :modo="observacaoSelecionada ? 'edicao' : 'inclusao'"
        :observacao="observacaoSelecionada"
        @fechar="fecharModalIncluirObservacao"
        @salvou="handleSalvouIncluirObservacao"
      />

      <!-- Trocar Nível -->
      <TrocarNivel
        v-if="!isLoading && detalhes.matricula && exibirModalTrocarNivel"
        :matricula="{ ...detalhes.matricula, turmas: detalhes.turmas }"
        :plano="detalhes.matricula"
        :turmasDisponiveis="detalhes.turmas"
        @salvou="handleTrocarNivelSucesso"
        @cancelar="fecharModalTrocarNivel"
      />

      <!-- Renovar Matrícula -->
      <RenovarMatricula
        v-if="!isLoading && detalhes.matricula && exibirModalRenovar"
        :planoAtual="{
          turmas: detalhes.turmas,
          id: detalhes.matricula?.id,
          numero_contrato: detalhes.matricula?.numero_contrato,
          aluno_id: detalhes.matricula?.aluno_id,
          aluno: detalhes.aluno?.nome,
          responsavel: detalhes.responsavel?.nome,
          responsavel_id: detalhes.matricula?.responsavel_id,
          categoria_id: detalhes.matricula?.categoria_id,
          categoria: getCategoriaNome(detalhes.matricula?.categoria_id),
          tipo_plano_id: detalhes.matricula?.tipo_plano_id,
          tipo_plano: getTipoPlanoDescricao(detalhes.matricula?.tipo_plano_id),
          aulas_semana: detalhes.matricula?.aulas_semana,
          quantidade_parcelas: detalhes.matricula?.quantidade_pagamentos,
          nivel_id: detalhes.matricula?.nivel_id,
          nivel: getNivelDescricao(detalhes.matricula?.nivel_id),
          inicio_vigencia: detalhes.matricula?.inicio_vigencia,
          termino_vigencia: detalhes.matricula?.termino_vigencia,
          data_matricula: detalhes.matricula?.data_matricula,
          valor: detalhes.matricula?.valor,
          desconto: detalhes.matricula?.desconto,
          valor_com_desconto: detalhes.matricula?.valor_com_desconto,
          forma_pagamento_id: detalhes.matricula?.forma_pagamento_id,
          forma_pagamento: detalhes.catalogos.formasPagamento.find(fp => fp.id === detalhes.matricula?.forma_pagamento_id)?.nome || '',
          data_vencimento: detalhes.matricula?.data_vencimento,
          convenio_id: detalhes.matricula?.convenio_id,
          convenio: detalhes.catalogos.convenios.find(c => c.id === detalhes.matricula?.convenio_id)?.nome || '',
          banco_numero: detalhes.pagamentoMatricula?.banco_numero,
          agencia: detalhes.pagamentoMatricula?.agencia,
          cheque_numero: detalhes.pagamentoMatricula?.cheque_numero,
          conta_financeira_id: detalhes.pagamentoMatricula?.conta_financeira_id,
          pagamento_pendente: detalhes.matricula?.pagamento_pendente,
          valor_mensalidade: detalhes.matricula?.valor_mensalidade,
          desconto_mensalidade: detalhes.matricula?.desconto_mensalidade,
          valor_com_desconto_mensalidade: detalhes.matricula?.valor_com_desconto_mensalidade,
          primeiro_vencimento: detalhes.matricula?.primeiro_vencimento,
          quantidade_pagamentos: detalhes.matricula?.quantidade_pagamentos,
          politica_cobranca_id: detalhes.matricula?.politica_cobranca_id,
          dia_vencimento_mensalidade: detalhes.matricula?.dia_vencimento_mensalidade,
          valor_total_mensalidade: detalhes.matricula?.valor_total,
          direito_imagem: detalhes.matricula?.direito_imagem

        }"
        @renovarSucesso="handleRenovarSucesso"
        @cancelar="fecharModalRenovar"
      />

      <!-- Trocar Plano -->
      <TrocarPlano
        v-if="!isLoading && detalhes.matricula && exibirModalTrocarPlano"
        :planoAtual="{
          turmas: detalhes.turmas,
          id: detalhes.matricula?.id,
          numero_contrato: detalhes.matricula?.numero_contrato,
          aluno_id: detalhes.matricula?.aluno_id,
          aluno: detalhes.aluno?.nome,
          responsavel: detalhes.responsavel?.nome,
          responsavel_id: detalhes.matricula?.responsavel_id,
          categoria_id: detalhes.matricula?.categoria_id,
          categoria: getCategoriaNome(detalhes.matricula?.categoria_id),
          tipo_plano_id: detalhes.matricula?.tipo_plano_id,
          tipo_plano: getTipoPlanoDescricao(detalhes.matricula?.tipo_plano_id),
          aulas_semana: detalhes.matricula?.aulas_semana,
          quantidade_parcelas: detalhes.matricula?.quantidade_pagamentos,
          nivel_id: detalhes.matricula?.nivel_id,
          nivel: getNivelDescricao(detalhes.matricula?.nivel_id),
          inicio_vigencia: detalhes.matricula?.inicio_vigencia,
          termino_vigencia: detalhes.matricula?.termino_vigencia,
          data_matricula: detalhes.matricula?.data_matricula,
          valor: detalhes.matricula?.valor,
          desconto: detalhes.matricula?.desconto,
          valor_com_desconto: detalhes.matricula?.valor_com_desconto,
          forma_pagamento_id: detalhes.matricula?.forma_pagamento_id,
          forma_pagamento: detalhes.catalogos.formasPagamento.find(fp => fp.id === detalhes.matricula?.forma_pagamento_id)?.nome || '',
          data_vencimento: detalhes.matricula?.data_vencimento,
          convenio_id: detalhes.matricula?.convenio_id,
          convenio: detalhes.catalogos.convenios.find(c => c.id === detalhes.matricula?.convenio_id)?.nome || '',
          pagamento_pendente: detalhes.matricula?.pagamento_pendente,
          valor_mensalidade: detalhes.matricula?.valor_mensalidade,
          desconto_mensalidade: detalhes.matricula?.desconto_mensalidade,
          valor_com_desconto_mensalidade: detalhes.matricula?.valor_com_desconto_mensalidade,
          primeiro_vencimento: detalhes.matricula?.primeiro_vencimento,
          quantidade_pagamentos: detalhes.matricula?.quantidade_pagamentos,
          // Apenas contexto visual da troca de plano. O backend relê com FOR UPDATE.
          politica_cobranca_id: detalhes.matricula?.politica_cobranca_id,
          dia_vencimento_mensalidade: detalhes.matricula?.dia_vencimento_mensalidade,
          valor_total_mensalidade: detalhes.matricula?.valor_total
        }"
        @trocarSucesso="handleTrocarPlanoSucesso"
        @cancelar="fecharModalTrocarPlano"
      />

      <!-- Imprimir Matrícula -->
      <ImprimirMatricula
        v-if="!isLoading && detalhes.matricula && exibirImprimirMatricula"
        :dadosContrato="dadosContrato"
        @fechar="fecharImprimirContrato"
      />
    </div>
  </div>
</template>


<script setup>
import { reactive, ref, onMounted, computed, nextTick, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/services/axios";
import globalUtils from "@/utils/globalUtils.js";

import FormSection from "@/components/Layout/FormSection.vue";
// import LoadingSpinner from "@/components/LoadingSpinner.vue";
import IncluirObservacao from '@/components/modals/IncluirObservacao.vue';
import RenovarMatricula    from '@/components/modals/RenovarMatricula.vue';
import TrocarNivel         from '@/components/modals/TrocarNivel.vue';
import TrocarPlano         from '@/components/modals/TrocarPlano.vue';
import ImprimirMatricula   from '@/components/modals/ImprimirMatricula.vue';

const route  = useRoute();
const router = useRouter();
const isLoading = ref(true);

const instance = getCurrentInstance();
const globalState = instance?.appContext.config.globalProperties.$globalState || null;

// Estado unificado
const composicaoTroca = ref(null);
const erroComposicaoTroca = ref('');
const detalhes = reactive({
  matricula:           null,
  aluno:               null,
  responsavel:         null,
  pagamentoMatricula:  null,
  parcelas:            [],
  turmas:              [],
  posvendas:           [],
  posvendasHistorico:  [],
  observacoesAluno:    [],
  prospeccao_origem: null,
  historicos: {
    renovacoes:   [],
    trocasPlano:  [],
    trocasNivel:  [],
    trancamentos: [],
    destrancamentos: []
  },
  catalogos: {
    convenios:          [],
    formasPagamento:    [],
    categoriasPlanos:   [],
    planosMatriculas:   [],
    tiposPlanos:        [],
    niveisTurmas:       [],
    contasFinanceiras:  [],
    tiposValores:       [],
    valores:            []
  }
});

// Última pós-venda ainda em `posvendas` (pela data_contato; desempata por id)
const ultimaPosvenda = computed(() => {
  const arr = detalhes.posvendas || []
  if (!arr.length) return null
  return [...arr].sort((a, b) => {
    const da = a.data_contato ? String(a.data_contato) : ''
    const db = b.data_contato ? String(b.data_contato) : ''
    if (da !== db) return db.localeCompare(da) // DESC por data
    return (b.id || 0) - (a.id || 0)          // desempate por id DESC
  })[0]
})

// Linhas da tabela: 1ª = atual de `posvendas`, depois o histórico "como está"
const historicoComAtual = computed(() => {
  const atual = ultimaPosvenda.value
  const hist  = detalhes.posvendasHistorico || []
  if (!atual) return hist
  const linhaAtual = {
    id: `pv-${atual.id}`, // chave sintética para o v-for
    data_contato: atual.data_contato || atual.criado_em,
    descricao: atual.descricao,
    proximo_contato: atual.proximo_contato,
    nome_usuario: atual.nome_usuario
  }
  return [linhaAtual, ...hist]
})


function formatarTelefoneComDdi(numero, ddi = '') {
  const n = String(numero || '').trim();
  if (!n) return '';

  // Se o número já foi salvo com DDI no próprio texto, não duplica.
  if (/^\+\d/.test(n)) return n;

  const d = String(ddi || '').trim();

  // Em dados antigos/snapshots sem DDI, preserva exatamente o que já estava salvo.
  if (!d) return n;

  return `${d} ${n}`.trim();
}

function editarObservacao(obs) {
  observacaoSelecionada.value = {
    ...obs,
    data_falta: obs.data_falta
      ? String(obs.data_falta).slice(0, 10)
      : null
  };

  exibirModalIncluirObservacao.value = true;
}

const dadosContrato = computed(() => {
  // calcula hoje por extenso
  const hojeExtenso = new Date().toLocaleDateString('pt-BR', {
    day:   'numeric',
    month: 'long',
    year:  'numeric'
  });

  // retorna o objeto completo
  return {
    matricula:         detalhes.matricula?.id,
    numero_contrato:   detalhes.matricula?.numero_contrato,
    inicio_vigencia:   globalUtils.formatarData(detalhes.matricula?.inicio_vigencia),
    termino_vigencia:  globalUtils.formatarData(detalhes.matricula?.termino_vigencia),

    aluno_nome:        detalhes.aluno?.nome,
    aluno_data_nascimento: globalUtils.formatarData(detalhes.aluno?.data_nascimento),

    // ✅ Plano Contratado (texto pronto para impressão)
    tipo_plano:        getTipoPlanoDescricao(detalhes.matricula?.tipo_plano_id),
    aulas_semana:      detalhes.matricula?.aulas_semana ?? '',
    nivel:             getNivelDescricao(detalhes.matricula?.nivel_id),

    // data de hoje por extenso
    data_hoje_extenso: hojeExtenso,

    responsavel_nome:  detalhes.responsavel?.nome,
    responsavel_rg:    detalhes.responsavel?.rg,
    responsavel_cpf:   detalhes.responsavel?.cpf,
    responsavel_email: detalhes.responsavel?.email,
    responsavel_endereco: detalhes.responsavel?.endereco,
    responsavel_bairro: detalhes.responsavel?.bairro,
    responsavel_cep:   detalhes.responsavel?.cep,
    responsavel_cidade: detalhes.responsavel?.municipio_nome,
    responsavel_uf:    detalhes.responsavel?.estado_nome,
    responsavel_socio: detalhes.responsavel?.socio === true ? 'Sim' : 'Não',
    responsavel_telefone:  formatarTelefoneComDdi(detalhes.responsavel?.telefone, detalhes.responsavel?.telefone_ddi),
    responsavel_celular:   formatarTelefoneComDdi(detalhes.responsavel?.celular, detalhes.responsavel?.celular_ddi),
    responsavel_telefone_ddi: detalhes.responsavel?.telefone_ddi,
    responsavel_celular_ddi:  detalhes.responsavel?.celular_ddi,

    aluno_cpf:         detalhes.aluno?.cpf,
    matricula_valor_com_desconto: globalUtils.formatarValor(valorComDescontoMensalidade),
    tabela_mensalidade: tabelaMensalidadeHtml.value
  };
});

// retorna classe vermelha se faltar ≤30 dias, senão azul
function vencimentoClasse(data) {
  if (!data) return '';
  const hoje = new Date();
  // montamos YYYY-MM-DDT00:00:00 para evitar deslocamento
  const [ymd] = data.split('T');
  const termo = new Date(`${ymd}T00:00:00`);
  const diffDias = (termo - hoje) / (1000 * 60 * 60 * 24);
  return diffDias <= 30 ? 'text-danger' : 'text-primary';
}

// formata sexo
const responsavelSexoFormatado = computed(() => {
  const s = detalhes.responsavel?.sexo;
  return s === 'F' ? 'Feminino' : s === 'M' ? 'Masculino' : s || '';
});
const alunoSexoFormatado = computed(() => {
  const s = detalhes.aluno?.sexo;
  return s === 'F' ? 'Feminino' : s === 'M' ? 'Masculino' : s || '';
});

// pega nome da categoria
const getCategoriaNome = id => {
  return detalhes.catalogos.categoriasPlanos.find(c => c.id === id)?.nome || 'Não informado';
};

// pega descrição do tipo de plano (nome + duração)
const getTipoPlanoDescricao = id => {
  const tp = detalhes.catalogos.tiposPlanos.find(x => x.id === id);
  return tp
    ? `${tp.nome} – ${tp.duracao} dias`
    : 'Não informado';
};

// pega descrição do nível
const getNivelDescricao = id => {
  return detalhes.catalogos.niveisTurmas.find(n => n.id === id)?.nivel || 'Não informado';
};

const editarPessoa = (tipo) => {
  let pessoaId = null;
  if (tipo === 'responsavel') {
    pessoaId = detalhes.matricula?.responsavel_id;
  } else if (tipo === 'aluno') {
    pessoaId = detalhes.matricula?.aluno_id;
  }
  const returnUrl = `/operacional/matriculas/${detalhes.matricula?.id}/detalhar`;
  router.push({
    name: 'EditarPessoaFisica',
    params: { id: pessoaId },
    query: { returnUrl }
  });
};

// Filtra apenas os registros financeiros do contrato atual.
const pagamentosContrato = computed(() => {
  const numeroContrato = detalhes.matricula?.numero_contrato;

  if (!Array.isArray(detalhes.parcelas) || !numeroContrato) {
    return [];
  }

  return detalhes.parcelas.filter(
    pagamento => String(pagamento?.contrato || '') === String(numeroContrato)
  );
});

const statusChequeNormalizado = (pagamento) =>
  String(pagamento?.cheque_status || 'NORMAL').trim().toUpperCase();

const isRegistroOriginalSubstituido = (pagamento) => {
  if (!pagamento) return false;

  const status = statusChequeNormalizado(pagamento);

  return (
    status === 'SUBSTITUIDO' ||
    status === 'DEVOLVIDO' ||
    Boolean(pagamento.pagamento_substituto_id)
  );
};

const isPagamentoSubstituto = (pagamento) => {
  if (!pagamento) return false;

  if (pagamento.pagamento_substituto === true) {
    return true;
  }

  /*
   * Fallback para ambientes ainda sem os metadados enriquecidos:
   * procura um cheque substituído com o mesmo vencimento.
   */
  return pagamentosContrato.value.some(origem =>
    Number(origem?.id) !== Number(pagamento?.id) &&
    origem?.data_vencimento === pagamento?.data_vencimento &&
    isRegistroOriginalSubstituido(origem)
  );
};

const prioridadeRegistroMensalidade = (pagamento) => {
  if (pagamento?.adicional) return 4;
  if (isRegistroOriginalSubstituido(pagamento)) return 1;
  if (isPagamentoSubstituto(pagamento)) return 2;
  return 3;
};

const compararPagamentosContrato = (a, b) => {
  const dataA = String(a?.data_vencimento || '').slice(0, 10);
  const dataB = String(b?.data_vencimento || '').slice(0, 10);

  if (dataA && dataB) {
    const comparacaoData = dataA.localeCompare(dataB);
    if (comparacaoData !== 0) return comparacaoData;
  } else if (!dataA && dataB) {
    return 1;
  } else if (dataA && !dataB) {
    return -1;
  }

  const prioridadeA = prioridadeRegistroMensalidade(a);
  const prioridadeB = prioridadeRegistroMensalidade(b);

  if (prioridadeA !== prioridadeB) {
    return prioridadeA - prioridadeB;
  }

  return Number(a?.id || 0) - Number(b?.id || 0);
};

const pagamentosContratoOrdenados = computed(() =>
  [...pagamentosContrato.value].sort(compararPagamentosContrato)
);

const vencimentosContratuais = computed(() => {
  const datas = pagamentosContrato.value
    .filter(pagamento =>
      pagamento &&
      !pagamento.adicional &&
      pagamento.data_vencimento
    )
    .map(pagamento => String(pagamento.data_vencimento).slice(0, 10));

  return [...new Set(datas)].sort();
});

const numeroParcelaContratual = (pagamento) => {
  if (!pagamento || pagamento.adicional) return null;

  const vencimento = String(pagamento.data_vencimento || '').slice(0, 10);
  const indice = vencimentosContratuais.value.indexOf(vencimento);

  return indice >= 0 ? indice + 1 : null;
};

const getFormaPagamentoNome = (formaId) => {
  const forma = (detalhes.catalogos.formasPagamento || []).find(
    item => Number(item.id) === Number(formaId)
  );

  return forma?.nome || 'Não informado';
};

const situacaoPagamento = (pagamento) => {
  const statusCheque = statusChequeNormalizado(pagamento);

  if (statusCheque === 'SUBSTITUIDO') {
    return {
      texto: 'Cheque substituído',
      classe: 'bg-secondary'
    };
  }

  if (statusCheque === 'DEVOLVIDO') {
    return {
      texto: 'Cheque devolvido',
      classe: 'bg-danger'
    };
  }

  if (isPagamentoSubstituto(pagamento)) {
    return {
      texto: 'Pagamento substituto',
      classe: 'bg-info text-dark'
    };
  }

  if (pagamento?.data_recebimento) {
    return {
      texto: 'Recebido',
      classe: 'bg-success'
    };
  }

  if (pagamento?.data_pagamento) {
    return {
      texto: 'A receber',
      classe: 'bg-warning text-dark'
    };
  }

  return {
    texto: 'Pendente',
    classe: 'bg-light text-dark border'
  };
};

const classeLinhaPagamento = (pagamento) => ({
  'linha-cheque-substituido': isRegistroOriginalSubstituido(pagamento),
  'linha-pagamento-substituto': isPagamentoSubstituto(pagamento),
  'linha-parcela-adicional': pagamento?.adicional === true,
  'linha-conciliada': pagamento?.bloqueado_por_conciliacao === true
});

const detalhesPagamentosAbertos = ref(new Set());

const detalhesPagamentoAberto = (pagamento) =>
  detalhesPagamentosAbertos.value.has(Number(pagamento?.id));

const alternarDetalhesPagamento = (pagamento) => {
  const id = Number(pagamento?.id);
  if (!id) return;

  const novaSelecao = new Set(detalhesPagamentosAbertos.value);

  if (novaSelecao.has(id)) {
    novaSelecao.delete(id);
  } else {
    novaSelecao.add(id);
  }

  detalhesPagamentosAbertos.value = novaSelecao;
};

const quantidadeChequesSubstituidos = computed(() =>
  pagamentosContrato.value.filter(
    pagamento => statusChequeNormalizado(pagamento) === 'SUBSTITUIDO'
  ).length
);

const quantidadePagamentosSubstitutos = computed(() =>
  pagamentosContrato.value.filter(isPagamentoSubstituto).length
);

const quantidadeConciliacoesAtivas = computed(() =>
  pagamentosContrato.value.reduce((total, pagamento) => {
    const conciliacoes = Array.isArray(pagamento?.conciliacoes_ativas)
      ? pagamento.conciliacoes_ativas.length
      : 0;

    return total + conciliacoes;
  }, 0)
);

const formatarMotivosBloqueio = (motivos) => {
  const mapa = {
    CONCILIACAO_ATIVA: 'Conciliação ativa',
    HISTORICO_CHEQUE: 'Histórico de cheque',
    PAGAMENTO_SUBSTITUTO: 'Pagamento substituto',
    REGISTRO_SUBSTITUIDO: 'Registro substituído',
    CHEQUE_SUBSTITUIDO: 'Cheque substituído',
    CHEQUE_DEVOLVIDO: 'Cheque devolvido'
  };

  const lista = Array.isArray(motivos) ? motivos : [];

  if (!lista.length) {
    return 'Registro financeiro protegido';
  }

  return lista.map(motivo => mapa[motivo] || motivo).join(' · ');
};

const formatarTipoEventoCheque = (tipoEvento) => {
  const mapa = {
    DEVOLUCAO: 'Devolução',
    REAPRESENTACAO: 'Reapresentação',
    COMPENSACAO: 'Compensação',
    SUBSTITUICAO: 'Substituição'
  };

  return mapa[String(tipoEvento || '').toUpperCase()] || tipoEvento || 'Evento';
};

const valorNumericoPagamento = (valor) => {
  if (valor === null || valor === undefined || valor === '') {
    return 0;
  }

  if (typeof valor === 'number') {
    return Number.isFinite(valor) ? valor : 0;
  }

  const texto = String(valor).trim();

  if (/^-?\d+(?:\.\d+)?$/.test(texto)) {
    const numero = Number(texto);
    return Number.isFinite(numero) ? numero : 0;
  }

  const normalizado = texto
    .replace(/\s/g, '')
    .replace(/R\$/gi, '')
    .replace(/\./g, '')
    .replace(',', '.');

  const numero = Number(normalizado);
  return Number.isFinite(numero) ? numero : 0;
};

// soma das parcelas adicionais — sem divisão por 100
const valorParcelasAdicionais = computed(() => {
  return pagamentosContrato.value
    .filter(p => p.adicional && p.valor)
    .reduce((sum, p) => sum + parseFloat(p.valor), 0);
});

// total incluindo adicionais
const valorTotalComParcelasAdicionais = computed(() => {
  // usamos o valorTotalMensalidade já calculado
  return valorTotalMensalidade.value + valorParcelasAdicionais.value;
});

// ID da última renovação (mais recente por created_at, desempate por id)
const ultimaRenovacaoId = computed(() => {
  const arr = detalhes.historicos.renovacoes || [];
  if (!arr.length) return null;

  const ordenadas = [...arr].sort((a, b) => {
    const da = a.created_at ? String(a.created_at) : '';
    const db = b.created_at ? String(b.created_at) : '';
    if (da !== db) return db.localeCompare(da); // mais recente primeiro
    return (b.id || 0) - (a.id || 0);          // desempata pelo id desc
  });

  return ordenadas[0].id;
});

// calcula valor com desconto da mensalidade
const valorComDescontoMensalidade = computed(() => {
  const base = parseFloat(detalhes.matricula?.valor_mensalidade) || 0;
  const desc = parseFloat(detalhes.matricula?.desconto_mensalidade) || 0;
  return base - (base * desc / 100);
});

const mensalidadeGerenciada = computed(() =>
  detalhes.matricula?.politica_cobranca_id != null ||
  pagamentosContrato.value.some(p =>
    !p.adicional && !isRegistroOriginalSubstituido(p) &&
    (p.politica_cobranca_id != null || (Array.isArray(p.composicoes) && p.composicoes.length > 0))
  )
);

// total sem adicionais: valor com desconto vezes quantidade de pagamentos
const valorTotalMensalidade = computed(() => {
  return detalhes.matricula?.valor_total == null ? null : Number(detalhes.matricula.valor_total);
});


const resumoComposicoesMensalidade = computed(() => {
  let totalProrata = 0;
  let totalCreditoTrocaPlano = 0;
  let primeiroProrata = null;

  pagamentosContrato.value
    .filter(pagamento => {
      if (!pagamento || pagamento.adicional) return false;
      if (isRegistroOriginalSubstituido(pagamento)) return false;

      return true;
    })
    .forEach(pagamento => {
      const composicoes =
        Array.isArray(
          pagamento?.composicoes
        )
          ? pagamento.composicoes
          : [];

      composicoes.forEach(
        composicao => {
          const tipo =
            String(
              composicao?.tipo ||
              ''
            ).toUpperCase();

          const valor =
            valorNumericoPagamento(
              composicao?.valor
            );

          if (
            tipo ===
            'PRORATA'
          ) {
            totalProrata +=
              valor;

            if (!primeiroProrata) {
              primeiroProrata =
                composicao;
            }

            return;
          }

          if (
            tipo ===
            'CREDITO_TROCA_PLANO'
          ) {
            totalCreditoTrocaPlano +=
              valor;
          }
        }
      );
    });

  return {
    totalProrata:
      Number(
        totalProrata.toFixed(2)
      ),

    totalCreditoTrocaPlano:
      Number(
        totalCreditoTrocaPlano
          .toFixed(2)
      ),

    primeiroProrata
  };
});


const totalEsperadoMensalidade = computed(() => {
  if (composicaoTroca.value) return valorNumericoPagamento(composicaoTroca.value.complemento);
  if (!mensalidadeGerenciada.value) return valorTotalMensalidade.value;

  const resumo =
    resumoComposicoesMensalidade.value;

  const total =
    valorTotalMensalidade.value +
    resumo.totalProrata -
    resumo.totalCreditoTrocaPlano;

  return Number(
    total.toFixed(2)
  );
});


const valorTotalComParcelasAdicionaisPrevisto = computed(() => {
  return Number(
    (
      totalEsperadoMensalidade.value +
      valorParcelasAdicionais.value
    ).toFixed(2)
  );
});


const mensagemComposicoesMensalidade = computed(() => {
  const resumo =
    resumoComposicoesMensalidade.value;

  const mensagens = [];

  if (
    resumo.totalProrata > 0
  ) {
    const prorata =
      resumo.primeiroProrata;

    const diasAtivos =
      Number(
        prorata?.dias_ativos
      );

    const diasCompetencia =
      Number(
        prorata?.dias_competencia
      );

    const diasTexto =
      Number.isInteger(
        diasAtivos
      ) &&
      diasAtivos > 0 &&
      Number.isInteger(
        diasCompetencia
      ) &&
      diasCompetencia > 0
        ? ` (${diasAtivos} de ${diasCompetencia} dias)`
        : '';

    const inicio =
      globalUtils.formatarData(
        detalhes.matricula
          ?.inicio_vigencia
      );

    mensagens.push(
      `Pró-rata aplicado: ${globalUtils.formatarValor(
        resumo.totalProrata
      )} referente à competência inicial a partir de ${inicio}${diasTexto}. O valor está incorporado ao primeiro título.`
    );
  }

  if (
    resumo
      .totalCreditoTrocaPlano >
    0
  ) {
    mensagens.push(
      `Crédito de troca de plano aplicado: ${globalUtils.formatarValor(
        resumo
          .totalCreditoTrocaPlano
      )}.`
    );
  }

  return mensagens.join(' ');
});


const totalLancamentosMensalidade = computed(() => {
  const total = pagamentosContrato.value
    .filter(pagamento => {
      if (!pagamento || pagamento.adicional) return false;
      if (isRegistroOriginalSubstituido(pagamento)) return false;
      return true;
    })
    .reduce(
      (soma, pagamento) =>
        soma + valorNumericoPagamento(pagamento.valor),
      0
    );

  return Number(total.toFixed(2));
});

const diferencaTotalMensalidade = computed(() => {
  const diferenca =
    totalLancamentosMensalidade.value -
    totalEsperadoMensalidade.value;

  return Number(diferenca.toFixed(2));
});

const existeDiferencaMensalidade = computed(() =>
  Math.abs(diferencaTotalMensalidade.value) > 0.009
);

const diferencaMensalidadeAbsoluta = computed(() =>
  Math.abs(diferencaTotalMensalidade.value)
);

const mensagemDiferencaMensalidade = computed(() => {
  if (detalhes.composicaoTroca) return existeDiferencaMensalidade.value
    ? 'O total dos novos lançamentos ordinários difere do complemento desta troca. Confira os valores acima.'
    : 'O total dos novos lançamentos ordinários confere com o complemento desta troca.';
  if (!existeDiferencaMensalidade.value) {
    return 'Os valores dos lançamentos conferem com o total esperado das mensalidades.';
  }

  if (diferencaTotalMensalidade.value > 0) {
    return `Os lançamentos estão ${globalUtils.formatarValor(
      diferencaMensalidadeAbsoluta.value
    )} acima do total esperado. Verifique se existe acréscimo, juros ou valor lançado a maior.`;
  }

  return `Faltam ${globalUtils.formatarValor(
    diferencaMensalidadeAbsoluta.value
  )} para atingir o total esperado das mensalidades.`;
});


// Função única de carregamento
async function carregarDetalhes() {
  try {
    const resp = await axios.get(`/operacional/matriculas/detalhes/${route.params.id}`);
    Object.assign(detalhes, resp.data);
    composicaoTroca.value = null;
    erroComposicaoTroca.value = '';
    if (detalhes.matricula?.politica_cobranca_id != null) {
      try {
        composicaoTroca.value = (await axios.get(`/operacional/matriculas/salvar-trocas-planos/composicao/${route.params.id}`)).data;
      } catch {
        erroComposicaoTroca.value = 'Composição da troca indisponível. Atualize os detalhes antes de conferir o saldo.';
      }
    }

    /*
     * Busca os pagamentos pelo endpoint enriquecido para obter:
     * substituições, eventos de cheque, conciliações e bloqueios.
     * Em caso de indisponibilidade, mantém as parcelas já retornadas
     * pelo endpoint de detalhes.
     */
    try {
      const parcelasResp = await axios.get(
        `/operacional/pagamentos-matriculas/${route.params.id}`
      );

      if (Array.isArray(parcelasResp.data)) {
        detalhes.parcelas = parcelasResp.data;
      }
    } catch (parcelasError) {
      console.warn(
        '⚠️ Não foi possível carregar os metadados financeiros enriquecidos.',
        parcelasError?.response?.status,
        parcelasError?.response?.data
      );
    }

    detalhesPagamentosAbertos.value = new Set();

    // Normaliza campos de data para "YYYY-MM-DD"
    const isoFields = [
      'inicio_vigencia',
      'termino_vigencia',
      'data_matricula',
      'primeiro_vencimento',
      'data_vencimento'
    ];
    isoFields.forEach(key => {
      if (detalhes.matricula?.[key]) {
        detalhes.matricula[key] = detalhes.matricula[key].slice(0, 10);
      }
    });

    if (detalhes.pagamentoMatricula) {
      ['data_vencimento','data_pagamento','data_recebimento']
        .forEach(key => {
          if (detalhes.pagamentoMatricula[key]) {
            detalhes.pagamentoMatricula[key] = detalhes.pagamentoMatricula[key].slice(0, 10);
          }
        });
    }
  } finally {
    isLoading.value = false;
    await nextTick();
    capturarTabelaHTML();
  }
}

// Captura HTML da tabela de mensalidades (para impressão)
const tabelaMensalidadeHtml = ref("");
const tabelaMensalidade     = ref(null);
function capturarTabelaHTML() {
  if (tabelaMensalidade.value) {
    tabelaMensalidadeHtml.value = tabelaMensalidade.value.innerHTML;
  }
}

// Computeds e funções utilitárias (adaptadas para usar `detalhes`)
const formatarCPF = cpf => {
  if (!cpf) return "";
  const s = cpf.replace(/\D/g,'');
  return s.length===11
    ? s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/,'$1.$2.$3-$4')
    : cpf;
};
const alunoCPFFormatado      = computed(() => formatarCPF(detalhes.aluno?.cpf));
const responsavelCPFFormatado = computed(() => formatarCPF(detalhes.responsavel?.cpf));

const isCheque = id => {
  const fp = (detalhes.catalogos.formasPagamento || []).find(
    forma => Number(forma.id) === Number(id)
  );

  return String(fp?.nome || '').trim().toLowerCase() === 'cheque';
};
const formatarConta = id => {
  const c = detalhes.catalogos.contasFinanceiras.find(x => x.id===id);
  return c
    ? `${c.apelido||'Sem apelido'} - ${c.agencia||'Sem agência'} - ${c.numero_conta||'Sem número'}`
    : "Não informado";
};

const statusExibido = computed(() => detalhes?.status_exibido || 'Ativo');

const statusColor = computed(() => ({
  Ativo: 'green',
  Trancado: 'red',
  Encerrado: 'brown',
  Arquivado: 'blue',
  Cancelado: 'red'
}[statusExibido.value] || 'inherit'));

// Demais refs para controle de modais
const exibirModalIncluirObservacao = ref(false);
const exibirModalRenovar          = ref(false);
const exibirModalTrocarNivel      = ref(false);
const exibirModalTrocarPlano      = ref(false);
const exibirImprimirMatricula     = ref(false);
let observacaoSelecionada         = ref(null);

// Métodos de abertura/fechamento de modais
function abrirModalIncluirObservacao() {
  observacaoSelecionada.value = null;
  exibirModalIncluirObservacao.value = true;
}
function fecharModalIncluirObservacao() {
  exibirModalIncluirObservacao.value = false;
  observacaoSelecionada.value = null;
}
async function handleSalvouIncluirObservacao() {
  await carregarDetalhes();
  exibirModalIncluirObservacao.value = false;
  observacaoSelecionada.value = null;
}
const abrirModalRenovar    = () => exibirModalRenovar.value = true;
const fecharModalRenovar   = () => exibirModalRenovar.value = false;
const abrirModalTrocarNivel= () => exibirModalTrocarNivel.value = true;
const fecharModalTrocarNivel=() => exibirModalTrocarNivel.value = false;
const abrirModalTrocarPlano= () => exibirModalTrocarPlano.value = true;
const fecharModalTrocarPlano=() => exibirModalTrocarPlano.value = false;
const abrirImprimirContrato = () => exibirImprimirMatricula.value = true;
const fecharImprimirContrato= () => exibirImprimirMatricula.value = false;
const cancelar = () => router.push('/operacional/matriculas');

const abrirImprimirRecibo = () => {
  // empurra para a rota nomeada ImprimirReciboMatricula passando o id
  router.push({
    name: 'ImprimirReciboMatricula',
    params: { id: detalhes.matricula.id }
  });
};

// Abrir recibo para um CONTRATO específico (usa query ?contrato=)
const abrirImprimirReciboContrato = (numeroContrato) => {
  if (!numeroContrato) return;
  router.push({
    name: 'ImprimirReciboMatricula',
    params: { id: detalhes.matricula.id },
    query: { contrato: String(numeroContrato) }
  });
};

const reverterUltimaRenovacao = async (renovacao) => {
  if (!detalhes.matricula?.id) {
    alert('Matrícula não carregada.');
    return;
  }

  const msg = [
    `Você está prestes a reverter a ÚLTIMA renovação desta matrícula.`,
    ``,
    `Contrato da renovação: ${renovacao.numero_contrato}`,
    ``,
    `Essa ação vai restaurar a matrícula para o estado anterior à renovação.`,
    `Use apenas quando a renovação foi feita por engano.`,
    ``,
    `Confirmar reversão?`
  ].join('\n');

  if (!window.confirm(msg)) return;

  try {
    const userName = globalState?.userName || null;

    const resp = await axios.post('/operacional/matriculas/desfazer-renovacao', {
      id_matricula: detalhes.matricula.id,
      nome_usuario: userName
    });
    console.log('Reversão OK:', resp.data);
    alert('Renovação desfeita com sucesso.');
    await carregarDetalhes(); // recarrega tudo: plano, pagamentos, históricos
  } catch (err) {
    console.error('Erro ao desfazer renovação:', err?.response || err);
    const msgErro = err?.response?.data?.detail || err?.response?.data?.error || 'Erro ao desfazer renovação.';
    alert(msgErro);
  }
};

function extrairFaltaOrigemId(texto) {
  const match = String(texto || "").match(
    /\[\[FALTA_ORIGEM_ID:(\d+)\]\]/i
  );

  return match ? Number(match[1]) : null;
}

function limparMarcadorHistorico(texto) {
  return String(texto || "")
    .replace(/\[\[FALTA_ORIGEM_ID:\d+\]\]\s*/gi, "")
    .trim();
}

function normalizarDataObservacao(value) {
  if (!value) return "";

  const texto = String(value).trim();
  const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) return "";

  return `${match[1]}-${match[2]}-${match[3]}`;
}

function formatarDataObservacaoBr(value) {
  const iso = normalizarDataObservacao(value);

  if (!iso) return "";

  const [ano, mes, dia] = iso.split("-");
  return `${dia}/${mes}/${ano}`;
}

function faltaAvisadaJaRevisada(obs) {
  if (!obs?.id || !obs?.falta_avisada) {
    return false;
  }

  const observacaoId = Number(obs.id);
  const dataOriginalBr = formatarDataObservacaoBr(
    obs.data_falta
  ).toLowerCase();

  return (detalhes.observacoesAluno || []).some((registro) => {
    const registroId = Number(registro?.id);

    if (!registroId || registroId === observacaoId) {
      return false;
    }

    /*
     * O cancelamento ou alteração deve ser posterior
     * ao registro original.
     */
    if (registroId <= observacaoId) {
      return false;
    }

    const origemMarcada = extrairFaltaOrigemId(
      registro.observacao
    );

    // Registros novos com o marcador
    if (origemMarcada === observacaoId) {
      return true;
    }

    /*
     * Compatibilidade com registros criados antes
     * da inclusão do marcador.
     */
    const texto = limparMarcadorHistorico(
      registro.observacao
    ).toLowerCase();

    const mencionaData =
      dataOriginalBr &&
      texto.includes(
        `falta avisada para o dia ${dataOriginalBr}`
      );

    const representaRevisao =
      texto.includes("foi cancelada") ||
      texto.includes("foi alterada para o dia");

    return mencionaData && representaRevisao;
  });
}


// Quando um modal altera dados, recarregamos tudo
async function handleRenovarSucesso()     { await carregarDetalhes(); fecharModalRenovar(); }
async function handleTrocarNivelSucesso()  { await carregarDetalhes(); fecharModalTrocarNivel(); }
async function handleTrocarPlanoSucesso()  { await carregarDetalhes(); fecharModalTrocarPlano(); }

// onMounted dispara o carregamento unificado
onMounted(() => carregarDetalhes());

</script>

<style scoped>
.section-title {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.disabled-input {
  background: #e9ecef;
  border: 1px solid #ced4da;
}

.btn-sm {
  height: 38px;
}

.turma-item {
  background: white;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.required {
  color: red;
}

.add-turma-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}

.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 50px;
  height: 25px;
}

.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch {
  display: flex;
  align-items: center;
}

.toggle-switch label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 15px;
  min-width: 60px;
  border-radius: 20px;
  font-weight: bold;
}

.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #949596;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 4px 16px;
  font-weight: bold;
  color: white;
  font-size: 14px;
  text-align: center;
  position: relative;
}

.toggle-input:checked + .toggle-label {
  background-color: #949596;
}

.toggle-label:before {
  content: "";
  position: absolute;
  left: 5px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.toggle-input:checked + .toggle-label:before {
  transform: translateX(35px);
}

.toggle-label span {
  flex: 1;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
}

.icons-container {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
}

.icons-container i {
  cursor: pointer;
  font-size: 1.2rem;
}

.historico-container {
  padding: 0.75rem;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-bottom: 0.5rem;
}

.historico-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.historico-title {
  font-size: 0.8rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

.historico-content {
  width: 100%;
  display: block;
  line-height: 1.2;
}

.table-responsive {
  max-height: 300px;
  overflow-y: auto;
}

.obs-pre {
  white-space: pre-wrap;     /* mantém \n e ainda quebra linha quando precisa */
  word-break: break-word;    /* evita estourar a tabela com palavras/strings longas */
}

.observacoes-aluno-table {
  width: 100%;
  table-layout: fixed;
}

.observacoes-aluno-table th:nth-child(1),
.observacoes-aluno-table td:nth-child(1) {
  width: 3%;
}

.observacoes-aluno-table th:nth-child(2),
.observacoes-aluno-table td:nth-child(2) {
  width: 9%;
}

.observacoes-aluno-table .col-observacao-aluno {
  width: 61%;
}

.observacoes-aluno-table .col-usuario-observacao {
  width: 20%;
  white-space: normal;
  overflow-wrap: break-word;
}

.observacoes-aluno-table th:last-child,
.observacoes-aluno-table td:last-child {
  width: 7%;
}

/* ============================================================
 * Mensalidade — resumo, conferência e tabela compacta
 * ============================================================ */

.mensalidade-dados-principais {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.mensalidade-dados-principais > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 7px;
}

.mensalidade-dado-label,
.conferencia-label,
.detalhe-label {
  color: #6c757d;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
}

.conferencia-mensalidade {
  border-top: 1px solid #dee2e6;
  padding-top: 12px;
}

.conferencia-card {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 70px;
  padding: 10px 12px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 7px;
}

.conferencia-card strong {
  font-size: 1rem;
}

.conferencia-ok {
  background: #edf8f0;
  border-color: #badbcc;
  color: #146c43;
}

.conferencia-alerta {
  background: #fff8e1;
  border-color: #ffda6a;
  color: #664d03;
}

.mensalidade-table-responsive {
  max-height: 520px;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #dee2e6;
  border-radius: 7px;
}

.mensalidade-table {
  width: 100%;
  min-width: 860px;
  table-layout: fixed;
}

.mensalidade-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
  vertical-align: middle;
  white-space: nowrap;
}

.mensalidade-table td {
  vertical-align: middle;
  overflow-wrap: anywhere;
}

.mensalidade-table .col-parcela {
  width: 7%;
}

.mensalidade-table .col-situacao {
  width: 15%;
}

.mensalidade-table .col-forma {
  width: 17%;
}

.mensalidade-table .col-data {
  width: 13%;
}

.mensalidade-table .col-valor {
  width: 11%;
}

.mensalidade-table .col-detalhes {
  width: 8%;
}

.btn-detalhes-pagamento {
  width: 32px;
  height: 30px;
  padding: 2px 6px;
}

.linha-cheque-substituido {
  background: #f4f5f6;
  border-left: 4px solid #6c757d;
}

.linha-pagamento-substituto {
  background: #eef8ff;
  border-left: 4px solid #0dcaf0;
}

.linha-parcela-adicional {
  background: #fff8e1;
  border-left: 4px solid #ffc107;
}

.linha-conciliada {
  box-shadow: inset 0 0 0 1px rgba(25, 135, 84, 0.18);
}

.linha-detalhes-pagamento td {
  padding: 14px;
  background: #fbfcfd;
}

.pagamento-detalhes-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.pagamento-detalhes-grid > div {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 9px 10px;
  background: #fff;
  border: 1px solid #e2e6ea;
  border-radius: 6px;
}

.detalhe-bloco {
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e2e6ea;
  border-radius: 6px;
}

.detalhe-item {
  color: #495057;
  font-size: 0.82rem;
}

.texto-com-quebras {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

@media (max-width: 992px) {
  .mensalidade-dados-principais,
  .pagamento-detalhes-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 576px) {
  .mensalidade-dados-principais,
  .pagamento-detalhes-grid {
    grid-template-columns: 1fr;
  }
}

</style>